<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title"><span *ngIf="all">All</span><span
                *ngIf="!all">Player</span> Transaction History</h2>
        <div class="page-section-actions">
            <div class="btn-group btn-group-sm" role="group">
                <button class="btn btn-outline-light" *ngIf="history_type !== 'consolidated'"
                    [ngClass]="{'active': all && !player_uuid}" (click)="showHistoryNew('all')">All</button>
                <button class="btn btn-outline-light"
                    [ngClass]="{'active': all && player_uuid}" (click)="showHistoryNew('player_all')">Player
                    All</button>
                <button class="btn btn-outline-light" [ngClass]="{'active': !all}"
                    (click)="showHistoryNew('date')">Date</button>
            </div>
            <input *ngIf="!all && history_type !== 'bank' && history_type !== 'consolidated'" class="form-control form-control-sm ms-1" type="date" [(ngModel)]="date"
                style="width:150px; background: rgba(255,255,255,0.9); border: none;" (change)="showHistoryNew('date')" />
        </div>
    </div>
    <form *ngIf="history_type === 'bank' || history_type === 'consolidated'" class="d-flex flex-wrap gap-2 align-items-end p-3" (ngSubmit)="initTable()">
        <label *ngIf="!all">From (MYT)<input name="bank_from" type="date" class="form-control form-control-sm" [(ngModel)]="bank_from"></label>
        <label *ngIf="!all">To (MYT)<input name="bank_to" type="date" class="form-control form-control-sm" [(ngModel)]="bank_to"></label>
        <label>Transaction<select name="transaction_type" class="form-select form-select-sm" [(ngModel)]="transaction_type">
            <option value="">{{history_type === 'consolidated' ? 'All transactions' : 'Top-up + Withdrawal'}}</option><option value="topup">Top-up only</option><option value="withdraw">Withdrawal only</option>
        <option *ngIf="history_type === 'consolidated'" value="transfer">Game transfers</option>
            <option *ngIf="history_type === 'consolidated'" value="adjustment">Adjustments</option>
        </select></label>
        <label *ngIf="history_type === 'consolidated'">Source<select name="record_source" class="form-select form-select-sm" [(ngModel)]="record_source">
            <option value="">All permitted sources</option><option value="bank">Bank</option>
            <option *ngIf="visible_tabs.includes('game')" value="game">Manual / Transfer game</option>
            <option *ngIf="visible_tabs.includes('wallet')" value="wallet">Seamless / Wallet</option>
        </select></label>
        <label *ngIf="history_type === 'bank'">Player<input name="bank_search" class="form-control form-control-sm" [(ngModel)]="bank_search" placeholder="Player code or name"></label>
        <button class="btn btn-primary btn-sm">Apply filters</button>
    </form>
    <div class="alert alert-danger" role="alert" *ngIf="filter_error">{{filter_error}}</div>
    <div class="page-section-filters" style="padding: 0;">
        <ul class="nav nav-tabs" style="border-bottom: none; padding: 6px 14px 0; gap: 2px;">
            <li class="nav-item" *ngIf="visible_tabs.includes('consolidated')">
                <a class="nav-link" [ngClass]="{'active': history_type === 'consolidated'}" (click)="loadTable('consolidated')">All sources</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('statement')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'statement'}"
                    (click)="loadTable('statement')">Statement</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('bank')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'bank'}" (click)="loadTable('bank')">Bank</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('game')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'game'}" (click)="loadTable('game')">Game</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('wallet')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'wallet'}"
                    (click)="loadTable('wallet')">Wallet</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('agent')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'agent'}" (click)="loadTable('agent')">Agent
                    Wallet</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('referral')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'referral'}"
                    (click)="loadTable('referral')">Referral Wallet</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('banker')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'banker'}"
                    (click)="loadTable('banker')">Banker Wallet</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('promotion')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'promotion'}"
                    (click)="loadTable('promotion')">Promotion</a>
            </li>
            <li class="nav-item" *ngIf="visible_tabs.includes('other')">
                <a class="nav-link" [ngClass]="{'active': history_type == 'other'}"
                    (click)="loadTable('other')">Adjustment</a>
            </li>
        </ul>
    </div>
    <div class="d-flex flex-row align-items-center px-3 py-2 bg-light border-bottom" *ngIf="history_type == 'bank'">
        <label class="me-2 mb-0 text-dark" style="font-size: 12px;">Bet Log End Date Range:</label>
        <select class="form-select form-select-sm" [(ngModel)]="end_date_mode" style="width: auto;">
            <option value="now">Till Now</option>
            <option value="next_deposit">Till Next Deposit</option>
            <option value="next_withdraw">Till Next Withdraw</option>
        </select>
    </div>
    <!-- Player Statement / Money Trail — reconciled summary header: where the money came from
         (deposits) and how the player won (net game P/L), tying out to the closing balance. -->
    <div class="px-3 pt-3" *ngIf="history_type == 'statement' && statement_summary">
        <div class="statement-summary">
            <div class="stmt-card">
                <div class="stmt-label">Total Deposit 总存款</div>
                <div class="stmt-value text-success">+{{ statement_summary.deposit | number:'1.2-2' }}</div>
            </div>
            <div class="stmt-card">
                <div class="stmt-label">Total Withdraw 总提款</div>
                <div class="stmt-value text-danger">-{{ statement_summary.withdraw | number:'1.2-2' }}</div>
            </div>
            <div class="stmt-card">
                <div class="stmt-label">Total Bet 总投注</div>
                <div class="stmt-value">{{ statement_summary.bet_stake | number:'1.2-2' }}</div>
            </div>
            <div class="stmt-card">
                <div class="stmt-label">Total Payout 总派彩</div>
                <div class="stmt-value">{{ statement_summary.bet_payout | number:'1.2-2' }}</div>
            </div>
            <div class="stmt-card">
                <div class="stmt-label">Net Win/Loss 净盈亏</div>
                <div class="stmt-value" [ngClass]="statement_summary.net_game >= 0 ? 'text-success' : 'text-danger'">
                    {{ statement_summary.net_game >= 0 ? '+' : '' }}{{ statement_summary.net_game | number:'1.2-2' }}
                </div>
            </div>
            <div class="stmt-card stmt-card-strong">
                <div class="stmt-label">Closing Balance 结余</div>
                <div class="stmt-value">{{ statement_summary.closing_balance | number:'1.2-2' }}</div>
            </div>
            <div class="stmt-card">
                <div class="stmt-label">Reconciled 对账</div>
                <div class="stmt-value">
                    <span class="badge" [ngClass]="statement_summary.reconciled ? 'bg-success' : 'bg-warning text-dark'">
                        {{ statement_summary.reconciled ? '✓' : '⚠ ' + (statement_summary.discrepancy | number:'1.2-2') }}
                    </span>
                </div>
            </div>
        </div>
        <div class="stmt-hint">
            Opening balance 上期结余: {{ statement_summary.opening_balance | number:'1.2-2' }}
            &nbsp;·&nbsp; Deposits show where money came in; Win/Loss shows game results — together they explain the balance.
        </div>
    </div>
    <div class="px-3 pt-3" *ngIf="empty_role_hint">
        <div class="alert alert-info mb-0" style="font-size: 13px;">
            <i class="fa fa-info-circle me-1"></i>{{ empty_role_hint }}
        </div>
    </div>
    <div class="page-section-body">
        <app-table #history (dataEvent)="onTableData($event)"></app-table>
    </div>
</div>
